/**
 * Account settings destinations.
 * Keep billing with notifications + privacy (account cluster), not primary browse nav.
 */

export type SettingsNavItem = {
  id: 'overview' | 'notifications' | 'billing' | 'privacy';
  label: string;
  description: string;
  to: string;
};

export const SETTINGS_NAV: SettingsNavItem[] = [
  {
    id: 'overview',
    label: 'Overview',
    description: 'All account settings',
    to: '/settings',
  },
  {
    id: 'notifications',
    label: 'Notifications',
    description: 'Push, email, and in-app alerts',
    to: '/settings/notifications',
  },
  {
    id: 'billing',
    label: 'Bilt:Spec Premium',
    description: 'Plans, billing, and subscription',
    to: '/settings/billing',
  },
  {
    id: 'privacy',
    label: 'Privacy and data',
    description: 'Export, cookies, and account controls',
    to: '/settings/privacy',
  },
];

export const SETTINGS_HUB_CARDS: Omit<SettingsNavItem, 'id'>[] = SETTINGS_NAV.filter(
  (item) => item.id !== 'overview'
).map(({ label, description, to }) => ({ label, description, to }));
